import React from 'react';
import { useUpdate, useNotify, useRefresh, useUpdateMany, useUnselectAll } from 'react-admin';
import { Button, Typography } from '@material-ui/core';
import ArchiveIcon from '@material-ui/icons/Archive';
import { translate } from '../../i18n/customI18nProvider';
import { notifyConfirm, notifySuccess } from '../../util';
import { Inbox } from '@material-ui/icons';

const ArchiveButton = ({ record, refreshSummary }) => {
    const [update, { loading }] = useUpdate();
    const notify = useNotify();
    const refresh = useRefresh();

    const handleArchive = async () => {
        const confirm = await notifyConfirm('custom.mypos_direct.confirm_archive');
        if (confirm.isConfirmed) {
            executeArchive();
        }
    };

    const executeArchive = () => {
        update(
            'v1/mypos_direct_transactions',
            record.id,
            { archived: true },
            record
        );

        notifySuccess('custom.element_archived');
        refresh();
        if (refreshSummary) {
            refreshSummary();
        }
    }

    if (!record) return null;

    if (record.archived) {
        return (
            <Button
                disabled={true}
                startIcon={<Inbox />}
                color="primary"
            >
                {translate('custom.archived')}
            </Button>
        )
    }

    return (
        <Button
            onClick={handleArchive}
            disabled={loading}
            startIcon={<ArchiveIcon />}
            color="primary"
        >
            {translate('custom.archive')}
        </Button>
    );
};

const BulkArchiveButton = props => {
    const [updateMany] = useUpdateMany();
    const notify = useNotify();
    const refresh = useRefresh();
    const unselectAll = useUnselectAll();

    const handleBulkArchive = async () => {
        const confirm = await notifyConfirm('custom.mypos_direct.confirm_archive_many');
        if (confirm.isConfirmed) {
            executeBulkArchive();
        }
    };

    const executeBulkArchive = () => {
        updateMany(
            'v1/mypos_direct_transactions',
            props.selectedIds,
            { archived: true },
            null
        );

        unselectAll("v1/mypos_direct_transactions");
        notifySuccess('custom.elements_archived');
        refresh();
        if (props.refreshSummary) {
            props.refreshSummary();
        }
    }

    return (
        <Button
            onClick={handleBulkArchive}
            color="primary"
            startIcon={<ArchiveIcon />}
        >
            {translate('custom.archive_selected')}
        </Button>
    );
}

export { ArchiveButton, BulkArchiveButton };